export enum Mode {
    DARK = 'dark',
    LIGHT = 'light'
}
export const STORAGE_KEY = 'theme';

export interface ThemeSchema {
    mode?: Mode;
}
